module.exports = __webpack_public_path__ + "static/seo-dentist.8508db40.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/vendors/seo-dentist.png
// module id = 662
// module chunks = 172845445241205